import React, { useEffect } from "react";
import MdaePopup, {
  MdaePopupTitle,
  MdaePopupContent,
  MdaePopupFooter,
  MdaePopupFooterEndButtons,
  MdaePopupFooterStartButtons,
} from "../../common_components/common_widgets/popup";
import MdaeButton from "../../common_components/common_widgets/button";
import "./index.scss";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { actions as asyncActions, callOperation } from "async-ops";
import { isEqual } from "lodash";
import "./index.scss";
import { TASK_TEMPLATE_WARNING_POPUP_MODE } from "./component";
import { TOGGLE_TASK_TEMPLATE_WARNING_POPUP } from "./reducers/task-template-reducer";
import { GET_TASK_TEMPLATE_LINKED_DATA } from "./services/get-task-template-linked-data";
import { DataGrid } from "devextreme-react";
import { Export } from "devextreme-react/data-grid";
import { DELETE_REF_TASK_FROM_PATHWAYS } from "./services/delete-ref-task-from-pathways";
import { deleteRefTask } from "./component";
import MdaeList from "../../common_components/common_widgets/list";
interface ITaskTemplateWarningPopup {
  toggleTaskTemplateWarningPopupVisible: (
    isVisible: boolean,
    mode?: string,
    height?: number | string,
    closeAfterSave?: boolean
  ) => void;
  saveTaskTemplate: (closeAfterSave: any) => void;
  toggleTaskTemplatePopup: (isVisible: any) => void;
}
const TaskTemplateWarningPopup: React.FC<ITaskTemplateWarningPopup> = (
  props
) => {
  const dispatch = useDispatch();
  const asyncAction = bindActionCreators(
    {
      asyncOperationStart: asyncActions.asyncOperationStart,
    },
    dispatch
  );
  const taskTemplateFormData: any = useSelector(
    (state) => state["taskTemplateReducer"].taskTemplateFormData,
    isEqual
  );
  const taskTemplateWarningPopupMode: string = useSelector(
    (state) => state["taskTemplateReducer"].taskTemplateWarningPopupMode,
    isEqual
  );
  const isCloseTaskTemplatePopup: string = useSelector(
    (state) => state["taskTemplateReducer"].isCloseTaskTemplatePopup,
    isEqual
  );
  const hasNextWarning: string = useSelector(
    (state) => state["taskTemplateReducer"].hasNextWarning,
    isEqual
  );
  const taskTemplateLinkedData: any = useSelector(
    (state: any) => state["taskTemplateReducer"].taskTemplateLinkedData,
    isEqual
  );
  useEffect(() => {
    if (taskTemplateFormData.refTaskId)
      asyncAction.asyncOperationStart(
        GET_TASK_TEMPLATE_LINKED_DATA,
        taskTemplateFormData.refTaskId
      );
  }, [taskTemplateFormData.refTaskId]);
  const onTaskTemplateWarningPopupModePrimaryButtonClick = (popupMode) => {
    switch (popupMode) {
      case TASK_TEMPLATE_WARNING_POPUP_MODE.CHANGES_ON_EXISTING_USER_TASKS_WARNING:
       props.saveTaskTemplate(isCloseTaskTemplatePopup);
        break;
      case TASK_TEMPLATE_WARNING_POPUP_MODE.CHNAGES_ON_TASK_TEMPLATE_LINKED_TO_PATHWAY_WARNING:
        if (hasNextWarning) {
           props.toggleTaskTemplateWarningPopupVisible(
             true,
             TASK_TEMPLATE_WARNING_POPUP_MODE.CHANGES_ON_EXISTING_USER_TASKS_WARNING,
             isCloseTaskTemplatePopup,
             false
           );
        } else props.saveTaskTemplate(isCloseTaskTemplatePopup);
        break;
      case TASK_TEMPLATE_WARNING_POPUP_MODE.DELETE_TASK_TEMPLATE_LINKED_TO_PATHWAY_WARNING:
        deleteRefTask(taskTemplateFormData, dispatch).then(() => {
          asyncAction.asyncOperationStart(
            DELETE_REF_TASK_FROM_PATHWAYS,
            taskTemplateFormData.refTaskId
          );
        });
        break;
    }
    if (!hasNextWarning)
     props.toggleTaskTemplateWarningPopupVisible(false);
  };

  const getPopupTitle = () => {
    return (
      <MdaePopupTitle
        isSmallPopup
        closePopupHandler={() => {
          props.toggleTaskTemplateWarningPopupVisible(false);
        }}
      >
        {TASK_TEMPLATE_WARNING_POPUP_MODE.DELETE_TASK_TEMPLATE_LINKED_TO_PROCESS_TEMPLATE === taskTemplateWarningPopupMode ? "Error" : "Warning"}
      </MdaePopupTitle>
    );
  };

  return (
    <MdaePopup
      deferRendering={false}
      width={500}
      height={310}
      className="task-template-warning-popup"
      mdaeTitleRender={getPopupTitle}
      mdaeDataUpdaterConfig={[
        {
          actionType: TOGGLE_TASK_TEMPLATE_WARNING_POPUP,
          reducerName: "taskTemplateReducer",
          widgetOptionBindings: {
            visible: "isTaskTemplateWarningPopupVisible",
          },
        },
      ]}
      mdaeContentRender={() => {
        return (
          <div>
            <MdaePopupContent>
              {/* conditional rendering based on warning popup mode */}
              {taskTemplateWarningPopupMode ===
                TASK_TEMPLATE_WARNING_POPUP_MODE.CHANGES_ON_EXISTING_USER_TASKS_WARNING && (
                <div>
                  There are existing tasks created from this template. All
                  existing tasks will be updated to reflect the new information.
                  Do you want to continue?
                </div>
              )}
              {taskTemplateWarningPopupMode ===
                TASK_TEMPLATE_WARNING_POPUP_MODE.CHNAGES_ON_TASK_TEMPLATE_LINKED_TO_PATHWAY_WARNING && (
                <div>
                  <div>
                    This task template is linked to the following pathways
                    and/or payer audit workflows.
                  </div>
                  <div>
                    <div>
                      <DataGrid
                        id="pnlAuditPathwaysLinkedToTaskExportableList"
                        showColumnHeaders={false}
                        showBorders
                        dataSource={
                          taskTemplateLinkedData.attachedAuditPathways
                        }
                        columns={[{ dataField: "name" }]}
                      >
                        <Export enabled={true} />
                      </DataGrid>
                    </div>
                    <div className="top-margin">
                      This change will update the tasks template within those
                      workflows and override any manual changes made to the task
                      templates. Do you want to continue?
                    </div>
                  </div>
                </div>
              )}
              {taskTemplateWarningPopupMode ===
                TASK_TEMPLATE_WARNING_POPUP_MODE.CANNOT_CHANGE_AUDIT_GROUPS_FOR_TASKS_LINKED_TO_PATHWAYS_WARNING && (
                <div>
                  <div className="message-section">
                    <div className="task-template-warning-popup-message">
                      This task template is linked to the following audit
                      pathways. Linked Audit Groups cannot be edited until the
                      task template is removed from the pathway.
                    </div>
                  </div>
                  <div>
                    <div>
                      <DataGrid
                        id="pnlRefTaskLinkedAuditPathwaysListForView"
                        showColumnHeaders={false}
                        showBorders
                        dataSource={
                          taskTemplateLinkedData.attachedAuditPathways
                        }
                        columns={[{ dataField: "name" }]}
                      >
                        <Export enabled={true} />
                      </DataGrid>
                    </div>
                  </div>
                </div>
              )}
              {taskTemplateWarningPopupMode ===
                TASK_TEMPLATE_WARNING_POPUP_MODE.DELETE_TASK_TEMPLATE_LINKED_TO_PATHWAY_WARNING && (
                <div>
                  <div>
                    Deleting this task will remove the task template from the
                    following pathways:
                  </div>
                  <div>
                    <div>
                      {taskTemplateLinkedData.attachedAuditPathways.map((x) => (
                        <div
                          style={{
                            padding: "10px 10px 0 10px",
                            fontWeight: 450,
                          }}
                        >
                          {x.name}
                        </div>
                      ))}
                    </div>
                    <div className="top-margin">
                      Deleting this task template cannot be undone. Do you want
                      to continue?
                    </div>
                  </div>
                </div>
              )}
              {taskTemplateWarningPopupMode ===
                TASK_TEMPLATE_WARNING_POPUP_MODE.DELETE_TASK_TEMPLATE_LINKED_TO_PROCESS_TEMPLATE && (
                <div>
                  <div>
                  This Task Template is in use in the following active Process Templates. You 
                  must either update the task template on these process templates before this task template can be deleted. Alternatively, you 
                  can add a term date to this task template to prevent it from being used with future process templates.
                  </div>
                  <div>
                    <div>
                        <div>
                      <MdaeList
                        displayExpr="eaProcessTemplateName"
                        id="EaProcessTemplateId"
                        dataSource={
                          taskTemplateLinkedData.attachedProcessTemplate
                        }
                      />
                    </div>
                     
                    </div>
                  </div>
                </div>
              )}
            </MdaePopupContent>
          </div>
        );
      }}
      mdaeFooterRender={() => {
        return (
          <MdaePopupFooter>
            {[
              TASK_TEMPLATE_WARNING_POPUP_MODE.CANNOT_CHANGE_AUDIT_GROUPS_FOR_TASKS_LINKED_TO_PATHWAYS_WARNING,
              TASK_TEMPLATE_WARNING_POPUP_MODE.DELETE_TASK_TEMPLATE_LINKED_TO_PROCESS_TEMPLATE
            ].includes(taskTemplateWarningPopupMode) || (
              <MdaePopupFooterStartButtons>
                <MdaeButton
                  id={"pnlTaskTemplateWarningPopupSecondaryButton"}
                  role={"secondary"}
                  onClick={() => {
                    props.toggleTaskTemplateWarningPopupVisible(false);
                  }}
                >
                  Cancel
                </MdaeButton>
              </MdaePopupFooterStartButtons>
            )}
            {taskTemplateWarningPopupMode ===
              TASK_TEMPLATE_WARNING_POPUP_MODE.DELETE_TASK_TEMPLATE_LINKED_TO_PROCESS_TEMPLATE && (
              <MdaePopupFooterEndButtons>
                <MdaeButton
                  id={"pnlTaskTemplateWarningPopupPrimaryButton"}
                  role={"primary"}
                  onClick={() => {
                    props.toggleTaskTemplateWarningPopupVisible(false);
                  }}
                >
                  Close
                </MdaeButton>
              </MdaePopupFooterEndButtons>
            )}
            {taskTemplateWarningPopupMode !==
              TASK_TEMPLATE_WARNING_POPUP_MODE.DELETE_TASK_TEMPLATE_LINKED_TO_PROCESS_TEMPLATE && (
              <MdaePopupFooterEndButtons>
                <MdaeButton
                  id={"pnlTaskTemplateWarningPopupPrimaryButton"}
                  role={"primary"}
                  onClick={() => {
                    onTaskTemplateWarningPopupModePrimaryButtonClick(
                      taskTemplateWarningPopupMode
                    );
                  }}
                >
                  OK
                </MdaeButton>
              </MdaePopupFooterEndButtons>
            )}
          </MdaePopupFooter>
        );
      }}
      
    ></MdaePopup>
  );
};

export default TaskTemplateWarningPopup;
